import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const AgentDeletedNotice = () => {
  const { t } = useTranslation('chats');

  return (
    <div
      data-testid="agent-deleted-notice"
      className="flex items-center gap-3 rounded-lg bg-warning px-4 py-3"
    >
      <InfoIcon
        data-testid="agent-deleted-notice-icon"
        aria-hidden
        className="size-5 shrink-0 text-warning-foreground"
      />
      <p className="text-sm leading-5 text-muted-foreground">
        {t('chats.agentDeletedNotice.thisToolIsNoLonger')}
      </p>
    </div>
  );
};
